App.filter('dateFilter', function() {
    return function(input) {
        if (input === null) {
            return 'N/A';
        }

        var date = moment.unix(input);

        return date.format("dddd, MMM Do YYYY");
    }
});